import { Injectable } from '@angular/core';
import {Subject} from 'rxjs/Subject';

@Injectable()
export class MessagingService {

    public message: Subject<any>;

    constructor() {
        this.message = new Subject<any>();
    }

    sendMessage(value: any): void {
        this.message.next(value);
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/core/service/messaging.service.ts